<template>
    <div v-if="notification" class="board-container">
        <div role="table" class="board-table board-table--view">
            <div role="rowgroup">
                <div role="row">
                    <div role="columnheader">
                        {{ notification.subject }}
                    </div>
                </div>
                <div role="row">
                    <div role="cell">
                        <ul class="board-view-data">
                            <li>작성일 : {{ notification.createdAt.toDate() }}</li>
                            <li>조회수 : {{ notification.viewCount }}</li>
                        </ul>
                    </div>
                </div>
                <div v-if="files.length" role="row">
                    <div role="cell">
                        <div class="board-view-file">
                            <span class="head">
                                <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 409 513.6" style="enable-background: new 0 0 409 513.6" xml:space="preserve">
                                    <path
                                        d="M41.5,452.8v-353c0-11,9-20,20-20h60v-19c0-11,9-20,20-20c11,0,20,9,20,20v141c0,11-9,20-20,20c-11,0-20-9-20-20v-82h-40v82
                                    c0,33.1,26.9,60,60,60c33.1,0,60-26.9,60-60v-122h145.9c11,0,20,9,20,20v353c0,11-9,20-20,20H61.5C50.5,472.8,41.5,463.8,41.5,452.8
                                    M85.3,39.8H61.5c-33.1,0-60,26.9-60,60v353c0,33.1,26.9,60,60,60h285.9c33.1,0,60-26.9,60-60v-353c0-33.1-26.9-60-60-60H197.7
                                    c-8.5-22.8-30.5-39-56.2-39S93.9,17,85.3,39.8"
                                    />
                                </svg>
                                첨부파일 :
                            </span>
                            <ul class="lists">
                                <li v-for="file in files" :key="file.url" class="ml-20">
                                    <a :href="file.href" download>{{ file.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div role="row">
                    <div role="cell">
                        <div class="board-content">
                            <div v-html="notification.content.replace(/\n/g, '<br>')"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="false" role="table" class="board-table board-table--preview">
            <div role="rowgroup">
                <div role="row">
                    <div role="columnheader">이전글</div>
                    <div role="cell">
                        <div class="title"><a href="">이전 게시글 제목입니다.</a></div>
                    </div>
                </div>
                <div role="row">
                    <div role="columnheader">이전글</div>
                    <div role="cell">
                        <div class="title"><a href="">다음 게시글 제목입니다.</a></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="board-buttons d-flex justify-end mt-20 mt-lg-30">
            <v-btn @click="$router.go(-1)" small outlined color="grey" class="h-lg-40px"><span class="color-grey">List</span></v-btn>
            <!-- <a class="button button--border-primary" @click="$router.go(-1)"><span>목록</span></a> -->
            <div v-show="false" class="right">
                <a class="button button--border" href=""><span>수정</span></a>
                <a class="button button--border" href=""><span>답글</span></a>
                <a class="button button--primary" href=""><span>삭제</span></a>
                <!-- <a class="button button--border" href=""><span>취소</span></a>
                <a class="button button--primary" href=""><span>확인</span></a> -->
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import download from "downloadjs";

export default {
    components: {},
    data() {
        return {
            notification: null,
        };
    },
    computed: {
        files() {
            return [{ href: this.notification?.upload, name: this.notification?.upload?.split("/")?.pop?.() }, ...(this.notification?.files || [])].filter(({ href }) => href);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        download,
        async init() {
            try {
                var { notification } = await api.v1.center.notifications.get({ _id: this.$route.params._notification });
                this.notification = notification;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>
